import React, { useContext } from 'react';
import styled from 'styled-components';
import { ModalStateContext } from '@utils/context';
import Title from '@components/elements/title';
import BackgroundSlash from '../components/backgroundSlash';
import { mixins, media, theme } from '@styles';
const { colors } = theme;

const BgContainer = styled.div`
  background: ${props => props.bgColor || colors['lightPurple']};
  position: relative;
  overflow: hidden;
`;
const Container = styled.div``;
const CTAContainer = styled.div`
  margin: 0 auto;
  padding-top: 160px;
  padding-bottom: 160px;
  ${media.bigGiant`padding-top: 130px; padding-bottom: 122px;`};
  ${media.giant`padding-top: 98px; padding-bottom: 88px;`};
  ${media.thone`display: block; padding: 46px 20px 36px 20px;`};
  ${media.tiny`display: block; padding: 46px 20px 36px 20px;`};
  text-align: center;
`;
// ${media.tablet`padding: 56px 20px 36px 20px;`};
const TextContainer = styled(Title)`
  color: ${({ textColor }) => (textColor ? `${colors[textColor]}` : colors.white)};
  text-align: center;
  padding-bottom: 66px;
  ${media.bigGiant`padding-bottom: 42px;`};
  ${media.giant`padding-bottom: 42px;`};
  ${media.thone`padding-bottom: 24px;`};
  span {
    color: ${colors.black};
    color: ${({ slashColor }) => (slashColor ? `${colors[slashColor]}` : colors.black)};
  }
`;

const CTAButton = styled.a`
  ${mixins.CTAButton};
  padding: 15px 56px;
  color: ${colors.darkPurple} !important;
  background-color: ${colors.yellow} !important;
  ${mixins.ctabutton24}
  ${media.giant`font-size: 18px; padding: 11px 48px;`};
  ${media.tablet`font-size: 16px; padding: 8px 30px;`};
  &:before {
    content: '';
    position: absolute;
    min-height: 90px;
    width: 225px;
  }
`;

const Line1 = styled(BackgroundSlash)`
  .slash-div {
    width: 400px;
    margin-left: calc(50vw - 400px) !important;
    background: linear-gradient(180deg, #8f68fb 56.81%, rgba(244, 252, 255, 0) 99.03%) !important;
  }
`;

const Line2 = styled(BackgroundSlash)`
  .slash-div {
    width: 400px;
    margin-left: calc(50vw) !important;
    background: linear-gradient(
      16.39deg,
      #6d3cf3 25.42%,
      rgba(255, 255, 255, 0) 113.96%
    ) !important;
  }
`;

const ItemCTA = props => {
  const { setModalOption } = useContext(ModalStateContext);
  return (
    <BgContainer>
      <Line1 lines={[1]} />
      <Line2 lines={[1]} />
      <Container className="lg-container">
        <CTAContainer>
          {props.header && (
            <TextContainer
              textColor={props.header.textColor}
              slashColor={props.header.slashColor}
              size={props.header.titleSize}
              slash={false}>
              {props.header.title}
              <span>.</span>
            </TextContainer>
          )}
          <CTAButton href="#" onClick={() => setModalOption({ isOpen: true })}>
            START NOW
          </CTAButton>
        </CTAContainer>
      </Container>
    </BgContainer>
  );
};

export default ItemCTA;
